import { estimateTextWidth, type MeasureText } from './lib/layout';

const LABEL_FONT = '600 10px';

let context: CanvasRenderingContext2D | null | undefined;

/** Measures text in the charts' y-label font (the page font, 10px semibold), estimating it where canvas isn't available. */
export const measureLabel: MeasureText = (text) => {
  if (context === undefined) {
    context = document.createElement('canvas').getContext('2d');
  }
  if (!context) return estimateTextWidth(text);
  context.font = `${LABEL_FONT} ${getComputedStyle(document.body).fontFamily}`;
  return context.measureText(text).width;
};
